import { Button } from 'app/agriculture/components/Button/Button';
import { Chip } from 'app/agriculture/infobox/common/Chip/Chip';
import { useRouteActions } from 'app/agriculture/router/useRouteActions';
import { isTaskOverdue } from 'app/agriculture/routes/Tasks/utils/isTaskOverdue';
import { useTask } from 'app/agriculture/queries/tasks/useTask';
import { TaskCompleteCheckbox } from 'app/agriculture/routes/Tasks/components/TaskCompleteCheckbox/TaskCompleteCheckbox';
import './TaskHeader.scss';
import { FlyToButton } from 'app/agriculture/components/FlyToButton/FlyToButton';
import { TaskLocationIcon } from '../TaskLocationIcon/TaskLocationIcon';
import { useCurrentUser } from 'app/agriculture/hooks/users/useCurrentUser';

interface TaskHeaderProps {
    taskId: string;
    enableTitleLink?: boolean;
}

export function TaskHeader({ taskId, enableTitleLink = false }: TaskHeaderProps) {
    const { assignees, endDate, isComplete, location, priority, title } = useTask({
        taskId,
    });
    const routeActions = useRouteActions();
    const isOverdue = isTaskOverdue({ isComplete, endDate });
    const currentUser = useCurrentUser();
    const isAssignedToCurrentUser = assignees.some((id) => id === currentUser.id);

    return (
        <div className="TaskHeader">
            <div className="TaskHeader__checkbox">
                <TaskCompleteCheckbox taskId={taskId} />
            </div>
            {location != null && enableTitleLink ? (
                <div className="TaskHeader__icon" data-testid="task-header-fly-to">
                    <FlyToButton position={[location.longitude, location.latitude]} />
                </div>
            ) : null}
            {!enableTitleLink && location != null ? (
                <div className="TaskHeader__icon" data-testid="task-header-location-icon">
                    <TaskLocationIcon
                        size={20}
                        priority={priority}
                        isOverdue={isOverdue}
                        isAssignedToActiveUser={isAssignedToCurrentUser}
                    />
                </div>
            ) : null}

            <h5 className="TaskHeader__title">
                {enableTitleLink ? (
                    <Button
                        variant="compact"
                        onClick={() => {
                            routeActions.goto(taskId, { type: 'Task' });
                        }}
                        text={title}
                    />
                ) : (
                    title
                )}
            </h5>
            {priority === 'High' && (
                <Chip className="TaskHeader__chip" text="High Priority" color="warning" />
            )}
            {isOverdue && <Chip className="TaskHeader__chip" text="Overdue" color="danger" />}
        </div>
    );
}
